import vuetify from "./vuetify";
import {
    FormatDateTimeEntryToLocaleString,
    validityDateUTCToJsDate
} from '../utils/date';

export class EventBus {
    constructor() {
        this.vue = new Vue();
    }

    _FormatDateTimeEntryToLocaleString(DateTime) {
        // very hacky way to provide these helper-function to blade-files/non-modules
        return FormatDateTimeEntryToLocaleString(DateTime);
    }

    _validityDateUTCToJsDate(validityDate, format = Laravel.activeDateformat) {
        // very hacky way to provide these helper-function to blade-files/non-modules
        return validityDateUTCToJsDate(validityDate, format);
    }

    _BackendDateUTCToToLocaleString(backendDate, format = Laravel.activeDateformat) {
        // very hacky way to provide these helper-function to blade-files/non-modules
        var dateMillis = validityDateUTCToJsDate(backendDate, format);
        return FormatDateTimeEntryToLocaleString(dateMillis);
    }

    fire(event, data = null) {
        this.vue.$emit(event, data);
    }

    listen(event, callback) {
        this.vue.$on(event, callback);
    }

    destroy(event) {
        this.vue.$off(event);
    }

    mountAsVueComponent(selector) {
        const VueEventBus = new Vue({
            vuetify,
            data: {
                'myuser_picture': Laravel.profile_picture,
                'myuser_firstname': Laravel.profile_firstname,
                'myuser_lastname': Laravel.profile_lastname,
                'myuser_email': Laravel.profile_email,
            },
            mounted() {
                EaseEventBus.listen('showModal', function (modal) {
                    $('#' + modal).modal('show');
                });

                EaseEventBus.listen('hideModal', function (modal) {
                    $('#' + modal).modal('hide');
                });

                EaseEventBus.listen('updateMyuserData', (data) => {
                    if (typeof data['profile_picture'] !== 'undefined') {
                        this.myuser_picture = data['remove_picture'] ? '' : data['profile_picture'];
                    }
                    if (typeof data['first_name'] !== 'undefined') {
                        this.myuser_firstname = data['first_name'];
                    }
                    if (typeof data['last_name'] !== 'undefined') {
                        this.myuser_lastname = data['last_name'];
                    }
                    if (typeof data['email'] !== 'undefined') {
                        this.myuser_email = data['email'];
                    }
                    if (typeof data['suppress_emails'] !== 'undefined') {
                        this.myuser_suppress_emails = data['suppress_emails'];
                    }
                });
            }
        });

        VueEventBus.$mount(`#${selector}`);
    }
}
